export const Config = {
  apiUrl: window.location.origin,
    reCAPTCHASiteKey: "6LcNAWIpAAAAAIANPsXvje0rH9rtodIpR4zMbdFJ",
};
